// DatetimeInput component
export default function (states = {}) {
    let root, instance;
    let instantiated = false;

    return {
        opened: false,

        get value() {
            return root._x_model ? root._x_model.get() : root.value;
        },

        set value(value) {
            root._x_model ? root._x_model.set(value) : (root.value = value);
        },

        instance() {
            return instance;
        },

        init() {
            root = this.$root;

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            try {
                instance.destroy();
            } catch (error) {}
        },

        instantiate() {
            if (instantiated) return;
            instantiated = true;

            const locale = window.App.locale === 'en' ? window.flatpickr.l10ns.en : Object.values(window[window.App.locale])[0];
            let config = states.config;

            if (typeof config === 'string') {
                config = this[config] || window[config] || {};
            }

            root.classList.add('bg-white');

            instance = flatpickr(
                root,
                Object.assign(
                    {
                        locale: Object.assign(locale, { rangeSeparator: states.rangeSeparator }),
                        mode: states.mode,
                        showMonths: states.showMonths,
                        dateFormat: states.format,
                        noCalendar: !/y|m|n|d|j/i.test(states.format),
                        enableTime: /g|h|i|s/i.test(states.format),
                        enableSeconds: states.format.includes('s'),
                        time_24hr: /G|H/.test(states.format),
                        minDate: states.minDate,
                        maxDate: states.maxDate,
                        formatDate: (value, format) => Helper.formatDate(value, format),
                        onOpen: (selectedDates, dateStr, instance) => {
                            this.opened = true;
                            instance.setDate(dateStr, false, states.format.replace(/a/i, 'K'));
                        },
                        onClose: (selectedDates, dateStr, instance) => {
                            this.opened = false;
                            this.value = dateStr;
                        },
                    },
                    config
                )
            );

            if (instance.config.enableTime && !states.format.includes('i')) {
                instance.minuteElement.parentElement.previousElementSibling.style.display = 'none';
                instance.minuteElement.parentElement.style.display = 'none';
            }

            if (states.format.includes('a')) {
                instance.amPM.style.textTransform = 'lowercase';
            }

            if (this.isInModal) {
                $(instance.calendarContainer).on('focusin', (event) => event.stopImmediatePropagation());
            }
        },
    };
}
